module.exports = __webpack_public_path__ + "static/media/DC_O_Fashion_RosetosandDKGrey.b8e186b1.png";